import { useEffect, useState } from 'react';
import { usePatternContext } from '../../../../context/PatternContext';
import styled from 'styled-components';
import { getInvestChips, getProfitChips } from '../formatOptions';
import { RegionProps } from '../../../search/FilterData';
import RegionService from '../../../../service/Region';

interface Props {
  sigunguList: RegionProps[];
  emdList: RegionProps[];
}

const SelectedPattern = ({ sigunguList, emdList }: Props) => {
  const { patternInfo } = usePatternContext();

  const investChips = getInvestChips(patternInfo, sigunguList, emdList);

  const profitChips = getProfitChips(patternInfo);

  return (
    <Container>
      <Section>
        <AlgorithmTitle>투자 알고리즘</AlgorithmTitle>
        <OptionContainer>
          {investChips.map((item) => (
            <OptionChip key={item.key}>
              {item.label && <OptionLabel>{item.label}</OptionLabel>}
              {item.value}
            </OptionChip>
          ))}
        </OptionContainer>
      </Section>
      <Section>
        <AlgorithmTitle>수익 알고리즘</AlgorithmTitle>
        <OptionContainer>
          {profitChips.map((item) => (
            <OptionChip key={item.key}>
              {item.label && <OptionLabel>{item.label}</OptionLabel>}
              {item.value}
            </OptionChip>
          ))}
        </OptionContainer>
      </Section>
    </Container>
  );
};

export default SelectedPattern;

const Container = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  background: #f7f8fc;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

const AlgorithmTitle = styled.div`
  color: #222;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;

const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
`;
const OptionChip = styled.div`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 2px;
  border-radius: 9999px;
  background: #fff;
  color: #222;
  font-size: 13px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;
const OptionLabel = styled.div`
  color: rgba(55, 56, 60, 0.61);
`;
